export const memberStatuses = Object.freeze({
  active: 'Active',
  onHold: 'On Hold',
  notActive: 'Not Active',
  expired: 'Expired',
  canceled: 'Canceled',
  nonMember: 'Non-member',
  staff: 'Staff',
});
